export type ActionAreaElementTypes = HTMLIcButtonElement | HTMLIcLinkElement;
